jQuery(function($) {
    $('.aanmelden').each(function() {
        // Reference the current .aanmelden block
        var $aanmeldenBlock = $(this);

        $aanmeldenBlock.find('.aanmelden__switch > span').on('click', function() {
            // Remove active classes only within this .aanmelden block
            $aanmeldenBlock.find('.aanmelden__switch > span').removeClass('active');
            $aanmeldenBlock.find('.aanmelden__content').removeClass('active');
            
            // Add active class to the clicked span
            $(this).addClass('active');

            // Show the correct content based on the clicked span
            if ($(this).hasClass('coach')) {
                $aanmeldenBlock.find('.aanmelden__content-coach').addClass('active');
            } else {
                $aanmeldenBlock.find('.aanmelden__content-gebruiker').addClass('active');
            }
        });
    });
});
